import { getApp } from "@/components/homePageComponent/js"
import store from "@/store"



export const  toGetApp=async()=>{
   
   var result =  await getApp({companyId:store.getters.company.companyId})
   var list =result.data
    // for(var i =0;i<10;i++){
    //     list=list.concat(result.data)
    // }
    store.dispatch('knowledgeAPPList',list)
    return list

}
   